import React, { useEffect } from 'react'
import CustomModal from '../../../../../../components/CroreUIModal'
import { CCol, CFormInput, CFormLabel, CFormSelect, CRow } from '@coreui/react'
import { IContact, PhoneBook } from '../../../../../../service/interfaces/contacts'
import { useDispatch, useSelector } from 'react-redux'
import { CopyByContactRequestAction, CopyByPhonebookRequestAction, GetUnpagedPhonebookRequestAction, MoveByContactRequestAction, resetContactPropsAction } from '../../../../../../service/actions/contactActions'
import CustomValuesHook from '../../../../../../Hooks/customValuesHook'
import { ContactStackRequirement, ContactStackType, MoveByPhonebookType } from '../../../../../../service/types/contacts/apiRequestTypes'

const PhonebookModal = ({ display = false, setDisplay, selectedList, operationType }:
    { display: boolean, setDisplay: Function, selectedList: IContact[], operationType: string }) => {
    const dispatch = useDispatch()
    const allPhonebook = useSelector((state: any) => state.contactReducer.unpagedPhonebook)
    const movePending = useSelector((state: any) => state.contactReducer.moveByContactPending)
    const copyPending = useSelector((state: any) => state.contactReducer.copyByContactPending)
    const moveSuccess = useSelector((state: any) => state.contactReducer.moveByContactSuccess)
    const copySuccess = useSelector((state: any) => state.contactReducer.copyByContactSuccess)



    const [states, setStates] = CustomValuesHook({ selectedPhonebook: '' })

    useEffect(() => {
        dispatch(GetUnpagedPhonebookRequestAction({
            pageSize: 10,
            pageNumber: 1,
            disablePaging: true,
            sortText: "",
            whereConditionText: ""
        }))
    }, [])

    const handleSubmit = () => {

        const paramsList: ContactStackType = {
            toPhoneBookId: states.selectedPhonebook,
            contacts: selectedList.map((item: ContactStackRequirement) => ({
                contactId: item.contactId,
                isActive: item.isActive,
                isPin: item.isPin,
                isStar: item.isStar,
                isInBlackList: item.isInBlackList,
                color: item.color,
            }))
        }
        if (operationType === 'copy') {

            dispatch(CopyByContactRequestAction(paramsList))
        }

        if (operationType === 'move') {

            dispatch(MoveByContactRequestAction(paramsList))
        }
    }

    useEffect(() => {

        if (moveSuccess || copySuccess) {
            setStates({ selectedPhonebook: undefined })
            setDisplay(false)
            dispatch(resetContactPropsAction())

        }

    }, [moveSuccess, copySuccess])


    const bodyComponent = () => {
        return (<div>
            <form>
                <CRow>
                    <CCol lg={12} xs={12} className='p-4'>
                        <CFormLabel htmlFor="nameInput">دفترتلفن
                            <span className="required"> * </span>
                        </CFormLabel>
                        <div className='position-relative'>
                            <CFormSelect
                                className='form-control'
                                value={states.selectedPhonebook}
                                onChange={(e) => { setStates({ selectedPhonebook: e.target.value }) }}
                            >
                                <option value={''}>یک دفترچه تلفن انتخاب کنید</option>
                                {allPhonebook.data.map((phonebook: PhoneBook, idx: number) =>
                                    <option key={idx} value={phonebook.id}>{phonebook.name}</option>)}



                            </CFormSelect>
                        </div>
                    </CCol>

                </CRow>
            </form>
        </div>)
    }

    const titleComponent = () => {
        return (<div style={{ fontSize: '14px' }}>انتقال مخاطبین به یک دفترچه تلفن</div>)
    }
    const footerComponent = () => {

        return (<div className='d-flex justify-content-end'>
            <button className='btn btn-default mx-2' onClick={() => setDisplay(false)} >انصراف</button>
            <button className='btn btn-primary' disabled={!states.selectedPhonebook || copyPending || movePending} onClick={handleSubmit}>ثبت</button>
        </div>)
    }
    return (
        <CustomModal
            setShow={() => setDisplay(false)}
            title={titleComponent}
            component={bodyComponent}
            show={display}
            footerComponent={footerComponent}
            size={'sm'}
            backdrop={true}
        />
    )
}

export default PhonebookModal